import { render, staticRenderFns } from "./TaskReview.vue?vue&type=template&id=ea5e9e40&scoped=true&"
import script from "./TaskReview.vue?vue&type=script&lang=js&"
export * from "./TaskReview.vue?vue&type=script&lang=js&"
import style0 from "./TaskReview.vue?vue&type=style&index=0&id=ea5e9e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5e9e40",
  null
  
)

export default component.exports